import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'ae-tabs',
  templateUrl: './ae-tabs.component.html',
  styles: [],
})
export class AeTabsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
  attrActive: string = 'data-active';

  public changeTabsOptions(e: Event) {
    e.preventDefault();
    let linkClicked = (e.target as Element).tagName.toLocaleLowerCase() == 'a';
    if (linkClicked) {
      let target = e.target as Element;

      if (target.parentElement?.parentElement?.parentElement) {
        let els =
          target.parentElement.parentElement.parentElement.getElementsByTagName(
            'ae-tabs-item'
          );

        for (let x = 0; x < els.length; x++) {
          els[x].removeAttribute(this.attrActive);
        }
      }

      if (target.parentElement?.parentElement)
        target.parentElement.parentElement.setAttribute(
          this.attrActive,
          this.attrActive
        );
    }
  }
}
